<template>
  <div>
    <b-row no-gutters class="d-flex justify-content-start">
      <b-col xl="3" lg="3" md="3" sm="6" cols="12" class="mt-1">
        <CardTopTable :data="firstCard" />
      </b-col>
      <b-col xl="3" lg="3" md="3" sm="6" cols="12" class="mt-1">
        <CardTopTable :data="secondCard" />
      </b-col>
    </b-row>

    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-rrhh-discounts'].refresh()"
    >
      <template #buttons>
        <b-button
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button>
      </template>

      <template #table>
        <b-table
          ref="ref-table-rrhh-discounts"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="id"
          :empty-text="$t('No matching records found')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(employee_id)="data">
            <router-link
              target="_blank"
              :class="[textLink]"
              :to="{
                name: 'rrhh-employees-information',
                params: { id: data.item.employee_id },
              }"
            >
              {{ data.item.full_name | capitalize }} </router-link
            ><br />
            <span style="opacity: 0.7">
              {{ data.item.area | capitalize }}
            </span>
          </template>
          <template #cell(status)="data">
            <b-badge :variant="getStatusVariant(data.item.status)">
              {{ $t(data.item.status) }}
            </b-badge>
          </template>
          <template #cell(discount_type_id)="data">
            <span> {{ data.item.discount_type }} </span>
          </template>
          <template #cell(total)="data">
            <span class="text-success"> S/.{{ data.value | currency }} </span>
          </template>
          <template #cell(quotas)="data">
            <span
              style="font-size: 15px"
              class="cursor-pointer"
              @click="openFractionsModal(data.item)"
            >
              <b-badge variant="light-info">
                {{ data.item.quotas }}
              </b-badge>
            </span>
          </template>
          <template #cell(created_by)="data">
            <span> {{ data.item.user_created | capitalize }} </span><br />
            <feather-icon
              icon="CalendarIcon"
              class="text-success"
              size="15"
              style="opacity: 0.7"
            />
            <span style="opacity: 0.7">
              {{ data.item.created_at | myGlobalDay }}
            </span>
          </template>
          <template #cell(user_authorized)="data">
            <span v-if="data.item.user_authorized">
              {{ data.item.user_authorized | capitalize }} </span
            ><br />
            <feather-icon
              v-if="data.item.user_authorized"
              icon="CalendarIcon"
              class="text-success"
              size="15"
              style="opacity: 0.7"
            />
            <span v-if="data.item.user_authorized" style="opacity: 0.7">
              {{ data.item.approved_at | myGlobalDay }}
            </span>
          </template>
          <template #cell(observation)="data">
            <div
              style="
                max-width: 20vw;
                word-wrap: break-word;
                white-space: normal;
              "
            >
              {{ data.item.observation }}
            </div>
          </template>

          <template #cell(sustento)="data">
            <div class="d-flex justify-content-center">
              <b-link
                v-if="data.item.sustento"
                :href="data.item.sustento"
                target="_blank"
              >
                <feather-icon icon="FileIcon" class="text-primary" />
              </b-link>
              <span v-else>-</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <!-- Approve Discount -->
            <feather-icon
              v-if="data.item.status == 'Pending'"
              icon="CheckSquareIcon"
              class="cursor-pointer text-success"
              size="17"
              v-b-tooltip.hover.left="$t('Approve Discount')"
              @click="openDiscountModal(data.item, 'approve')"
            />

            <!-- Edit Discount -->
            <feather-icon
              v-if="data.item.status == 'Pending'"
              icon="EditIcon"
              class="cursor-pointer text-warning ml-1"
              size="17"
              v-b-tooltip.hover.left="$t('Edit Discount')"
              @click="openDiscountModal(data.item, 'edit')"
            />

            <!-- View Tracking -->
            <feather-icon
              v-if="data.item.status != 'Pending'"
              icon="ListIcon"
              class="cursor-pointer text-success"
              size="17"
              v-b-tooltip.hover.left="$t('View Tracking')"
              @click="openDiscountTrackingModal(data.item)"
            />

            <!-- Anulle Discount -->
            <feather-icon
              v-if="data.item.status == 'Pending'"
              icon="Trash2Icon"
              class="cursor-pointer text-danger ml-1"
              size="17"
              v-b-tooltip.hover.left="$t('Anulle Discount')"
              @click="openDiscountModal(data.item, 'anulle')"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <FractionsModal
      v-if="fractionsModal"
      :modalData="modalData"
      @hideModal="fractionsModal = false"
    />

    <DiscountModal
      v-if="discountModal"
      :modalData="modalData"
      @hideModal="hideDiscountModal"
    />

    <DiscountTrackingModal
      v-if="discountTrackingModal"
      :modalData="modalData"
      @hideModal="discountTrackingModal = false"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

/* Data */
import Fields from "@/views/commons/discounts/data/Fields.data.js";
import Filters from "@/views/commons/discounts/data/Filters.data.js";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CardTopTable from "@/views/commons/cards/CardTopTable.vue";

/* Modals */
import FractionsModal from "@/views/commons/discounts/components/modals/FractionsModal.vue";
import DiscountModal from "@/views/commons/discounts/components/modals/DiscountModal.vue";
import DiscountTrackingModal from "@/views/commons/discounts/components/modals/DiscountTrackingModal.vue";

/* Services */
import ViaticService from "@/views/monitoring/views/viatic/services/viatic.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";

import DiscountService from "@/views/commons/discounts/services/discounts.service.js";

export default {
  components: {
    FilterSlot,
    FractionsModal,
    DiscountModal,
    DiscountTrackingModal,
    CardTopTable,
  },
  // props: {
  //   tab: {
  //     type: String,
  //     require: true,
  //   },
  // },
  data() {
    return {
      filters: Filters,
      params: 1,
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      initDateSelect: "",
      modalData: {},
      fractionsModal: false,
      discountModal: false,
      discountTrackingModal: false,
      initDate: moment().startOf("week").add(1, "days").format("YYYY-MM-DD"),
      endDate: moment().endOf("week").add(1, "days").format("YYYY-MM-DD"),
      minDate: new Date(1000, 1, 1),
      maxDate: new Date(2050, 9, 1),
      weekly: "",
      firstCard: {
        title: "Pending Discounts",
        icon: 1,
        total: 0,
        subtitle: "Total",
        color: "primary",
      },
      secondCard: {
        title: "Pending Current Month Discounts",
        icon: 2,
        total: 0,
        subtitle: "Total",
        color: "primary",
      },
    };
  },
  computed: {
    showFields() {
      this.fields.map((row) => (row.visible = true));

      let fieldsVisible = this.fields.filter((item) => item.visible);
      fieldsVisible = fieldsVisible.map((element) => ({
        ...element,
        label: this.$t(element.label),
      }));
      return fieldsVisible;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  async created() {
    await Promise.all([
      this.getAreas(),
      this.getDiscountTypes(),
      this.getPendingDiscountsSum(),
    ]);
    // this.initDateSelect = this.initDate;
  },
  methods: {
    async exportToExcel(ctx) {
      try {
        let order = 8;
        switch (ctx.sortBy) {
          case "employee_id":
            order = 4;
            break;
          case "discount_type_id":
            order = 5;
            break;
          case "created_at":
            order = 8;
            break;
          case "updated_at":
            order = 9;
            break;
          default:
            order = 8;
            break;
        }
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: null,
          from: this.filters[0].model,
          to: this.filters[1].model,
          area_id: this.filters[2].model,
          discount_type_id: this.filters[3].model,
          module_id: this.currentUser.modul_id,
          estado: this.filters[4].model,
        };
        const response = await DiscountService.exportToExcel(params);

        let filename = "DESCUENTOS.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition && disposition.includes("filename=")) {
          filename = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "")
            .trim();
        }

        this.forceFileDownload(response.data, filename);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async getPendingDiscountsSum() {
      try {
        const { data } = await DiscountService.getPendingDiscountsSum();
        this.firstCard.total = data.total_pending_discounts;
        this.secondCard.total = data.current_month_pending_discounts;
      } catch (error) {
        this.showToastError(this.$t(error), "Error");
      }
    },

    getStatusVariant(status) {
      switch (status) {
        case "Pending":
          return "light-warning";
        case "Approved":
          return "light-success";
        case "Paid":
          return "light-primary";
        case "Anulled":
          return "light-info";
      }
    },
    async myProvider(ctx) {
      try {
        let order = 8;
        switch (ctx.sortBy) {
          case "employee_id":
            order = 4;
            break;
          case "discount_type_id":
            order = 5;
            break;
          case "created_at":
            order = 8;
            break;
          case "updated_at":
            order = 9;
            break;
          default:
            order = 8;
            break;
        }
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: null,
          from: this.filters[0].model,
          to: this.filters[1].model,
          area_id: this.filters[2].model,
          discount_type_id: this.filters[3].model,
          module_id: this.currentUser.modul_id,
          estado: this.filters[4].model,
        };
        const { data } = await DiscountService.getDiscounts(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getAreas() {
      try {
        const { data } = await EmployeeService.getAllAreas({
          moduleId: this.currentUser.modul_id,
        });
        this.filters[2].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDiscountTypes() {
      try {
        const { data } = await DiscountService.getDiscountTypes();
        this.filters[3].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    openFractionsModal(data) {
      this.modalData.discount_id = data.id;
      this.modalData.full_name = data.full_name;
      this.fractionsModal = true;
    },
    openDiscountModal(data, action) {
      if (action == "edit" || action == "approve" || action == "anulle") {
        this.modalData.id = data.id;
        this.modalData.action = action;
        this.discountModal = true;
      }
    },
    hideDiscountModal(action = false) {
      if (action == true) {
        this.refreshTable();
      }
      this.discountModal = false;
    },
    openDiscountTrackingModal(data) {
      this.modalData.discount_id = data.id;
      this.modalData.full_name = data.full_name;
      this.discountTrackingModal = true;
    },
    async anulleDiscount(data) {
      try {
        const confirm = await this.showConfirmSwal();
        if (confirm.isConfirmed) {
          const params = {
            discount_id: data.id,
            user_id: this.currentUser.id,
          };
          const { data } = await DiscountService.anulleDiscount(params);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    refreshTable() {
      this.$refs["ref-table-rrhh-discounts"].refresh();
    },
  },
  watch: {
    initDateSelect(newVal, oldVal) {
      this.initDate = moment(newVal)
        .startOf("week")
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.endDate = moment(newVal)
        .startOf("week")
        .add(7, "days")
        .format("YYYY-MM-DD");

      this.fields[5].label =
        "Mon " + moment(newVal).startOf("week").add(1, "days").format("MM-DD");
      this.fields[6].label =
        "Tue " + moment(newVal).startOf("week").add(2, "days").format("MM-DD");
      this.fields[7].label =
        "Wed " + moment(newVal).startOf("week").add(3, "days").format("MM-DD");
      this.fields[8].label =
        "Thu " + moment(newVal).startOf("week").add(4, "days").format("MM-DD");
      this.fields[9].label =
        "Fri " + moment(newVal).startOf("week").add(5, "days").format("MM-DD");
      this.fields[10].label =
        "Sat " + moment(newVal).startOf("week").add(6, "days").format("MM-DD");
      this.fields[11].label =
        "Sun " + moment(newVal).startOf("week").add(7, "days").format("MM-DD");
      var a = moment(newVal).startOf("week").add(1, "days");
      var b = moment().startOf("week").add(1, "days");
      this.week = a.diff(b, "weeks");
    },
  },
};
</script>

<style>
.k-datepicker {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.k-datepicker span {
  border-width: 0 !important;
  background-color: transparent !important;
}

.k-datepicker:hover {
  background-color: transparent !important;
  border-width: thin;
  border-style: solid;
  border-color: #ced4da;
}
.dark-layout .k-datepicker:hover {
  background-color: transparent !important;
}
.k-state-hover .k-state-focused {
  background-color: transparent !important;
  border-color: transparent !important;
}
.k-widget.form-control .k-input {
  height: 2.5rem !important;
}
</style>
